// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2vInB","icon":"styles_icon__7Rw-4"};